var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgContainer"},[_c('img',{class:_vm.type,attrs:{"src":("./img/" + _vm.content),"id":_vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }